import React from "react";
import {connect} from "react-redux";
import {updatePage} from "../../actions/page";
import {
    Alert,
    Button,
    Card, Checkbox,
    Col,
    Divider,
    Form,
    InputNumber,
    List, message,
    Row,
    Select,
    Tooltip,
    Typography
} from "antd";
import {CheckSquareOutlined, CloseSquareOutlined} from "@ant-design/icons";
import {createWebsiteSetupOrder} from "../../actions/services";
import {displayErrors} from "../../libs/utils";

class DoneForYouPBN extends React.Component {
    state = {
        websiteCount: 1,
        contentCount: 15,
        premiumTheme: false,
        managedHosting: false,
        whiteGloveDomainPicking: false,

        contentCost: 150,
        websiteCost: 250,
        premiumThemeCost: 75,
        managedHostingCost: 500,

        agreeTerms: false,
        loading: false,
    };

    calculateTotalCost() {
        let totalCost = 0;

        totalCost += this.state.websiteCount * this.state.websiteCost;
        totalCost += this.state.websiteCount * (this.state.contentCost * ((this.state.contentCount-15) / 15));
        totalCost += this.state.premiumTheme ? this.state.websiteCount * this.state.premiumThemeCost : 0;
        totalCost += this.state.managedHosting ? this.state.managedHostingCost : 0;

        return totalCost.toFixed(2);
    }

    createOrder() {
        if(this.state.websiteCount < 1 || this.state.websiteCount > 100) {
            return message.error('Please enter a valid website count between 1 and 100!');
        }

        if([15, 30, 50, 75, 100].indexOf(this.state.contentCount) === -1) {
            return message.error('Please enter a valid content count between 15 and 100!');
        }

        let data = {
            website_count: this.state.websiteCount,
            content_count: this.state.contentCount,
            premium_theme: this.state.premiumTheme,
            managed_hosting: this.state.managedHosting,
            white_glove_domain_picking: this.state.whiteGloveDomainPicking,
        }

        this.setState({ loading: true });

        this.props.createWebsiteSetupOrder(data, (res) => {
            this.setState({ loading: false });
            message.success('Order successfully placed, redirecting to invoice...', 5);
            this.props.history.push('/billing/invoices/' + res.data.invoice_id);
        }, (err) => {
            if(typeof err.response !== 'undefined') {
                this.setState({ loading: false });
                displayErrors(err.response.data);
            }
        });
    }

    render() {
        const { Option } = Select;

        return(
            <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                    <Card title='Order Form' size='small' >
                        <Form layout='vertical'>
                            <Form.Item label='Website count' help={<small>How many websites would you like to order?</small>}>
                                <Row gutter={[16, 16]} align="middle">
                                    <Col xs={24} md={21}>
                                        <InputNumber style={{ width: '100%' }} min={1} max={100} defaultValue={1} value={this.state.websiteCount} onChange={(value) => this.setState({ websiteCount: value })} />
                                        {this.state.websiteCount >= 100 ? <div><br /><Alert showIcon type='info' message='If you wish to order more than 100 websites, please contact our support!' /></div> : ''}
                                    </Col>
                                    <Col xs={24} md={3}>
                                        <Tooltip title={<div>{this.state.websiteCount} website{this.state.websiteCount > 1 ? 's' : ''}</div>}>
                                            <Typography.Title className='text-center' style={{ margin: 0, cursor: 'help' }} level={5}>
                                                ${this.state.websiteCount * this.state.websiteCost}.00
                                            </Typography.Title>
                                        </Tooltip>
                                    </Col>
                                </Row>
                            </Form.Item>
                            <Form.Item label='Article count' help={<small>How many articles <b><u>per website</u></b> do you need?</small>}>
                                <Row gutter={[16, 16]} align="middle">
                                    <Col xs={24} md={21}>
                                        <Select defaultValue={9} value={this.state.contentCount} onChange={(value) => this.setState({contentCount: value })}>
                                            <Option value={15}>15 articles</Option>
                                            <Option value={30}>30 articles</Option>
                                            <Option value={50}>50 articles</Option>
                                            <Option value={75}>75 articles</Option>
                                            <Option value={100}>100 articles</Option>
                                        </Select>
                                    </Col>
                                    <Col xs={24} md={3}>
                                        <Tooltip title={<div>{this.state.websiteCount} website{this.state.websiteCount > 1 ? 's' : ''}, {this.state.websiteCount > 1 ? 'each website ' : ''}{this.state.contentCount} pieces of content.</div>}>
                                            <Typography.Title className='text-center' style={{ margin: 0, cursor: 'help' }} level={5}>
                                                ${this.state.websiteCount * (this.state.contentCost * ((this.state.contentCount-15) / 15))}.00
                                            </Typography.Title>
                                        </Tooltip>
                                    </Col>
                                </Row>
                            </Form.Item>
                            <Form.Item label='Licensed premium themes' help={<small>Would you like licensed premium themes for your websites?</small>}>
                                <Row gutter={[16, 16]} align="middle">
                                    <Col xs={24} md={21}>
                                        <Select defaultValue={false} value={this.state.premiumTheme} onChange={(value) => this.setState({ premiumTheme: value })}>
                                            <Option value={false}>No, thank you</Option>
                                            <Option value={true}>Yes, please</Option>
                                        </Select>
                                    </Col>
                                    <Col xs={24} md={3}>
                                        <Tooltip title={<div>{this.state.websiteCount} website{this.state.websiteCount > 1 ? 's' : ''}, {this.state.websiteCount > 1 ? 'each website ' : ''}has a premium theme.</div>}>
                                            <Typography.Title className='text-center' style={{ margin: 0, cursor: 'help' }} level={5}>
                                                ${this.state.premiumTheme ? this.state.websiteCount * this.state.premiumThemeCost : 0 }.00
                                            </Typography.Title>
                                        </Tooltip>
                                    </Col>
                                </Row>
                            </Form.Item>
                            <Form.Item label='Managed hosting' help={<small>Would you like us to manage your hosting and websites <b><u>for 12 months</u></b>?</small>}>
                                <Row gutter={[16, 16]} align="middle">
                                    <Col xs={24} md={21}>
                                        <Select defaultValue={false} value={this.state.managedHosting} onChange={(value) => this.setState({ managedHosting: value })}>
                                            <Option value={false}>No, thank you</Option>
                                            <Option value={true}>Yes, please</Option>
                                        </Select>
                                    </Col>
                                    <Col xs={24} md={3}>
                                        <Typography.Title className='text-center' style={{ margin: 0 }} level={5}>
                                            ${this.state.managedHosting ? this.state.managedHostingCost : 0 }.00
                                        </Typography.Title>
                                    </Col>
                                </Row>
                            </Form.Item>
                            <Form.Item label='White glove domain service' help={<small>Access white glove domain service from <a href='https://odys.global' target='_blank' rel='noopener noreferrer'><b>Odys Global</b></a>. Minimum of 10 websites required! No domain purchase requirements.</small>}>
                                <Row gutter={[16, 16]} align="middle">
                                    <Col span={21}>
                                        <Select disabled={this.state.websiteCount < 10} defaultValue={false} value={this.state.whiteGloveDomainPicking} onChange={(value) => this.setState({ whiteGloveDomainPicking: value })}>
                                            <Option value={false}>No, thank you</Option>
                                            <Option value={true}>Yes, please</Option>
                                        </Select>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </Form>
                        <Divider />
                        <Row gutter={[16, 16]} align="middle">
                            <Col xs={24} md={21}>
                                <Typography.Title className='text-right' style={{ margin: 0 }}  level={5}>
                                    Total cost:
                                </Typography.Title>
                            </Col>
                            <Col xs={24} md={3}>
                                <Typography.Title className='text-center' style={{ margin: 0, cursor: 'help' }} level={5}>
                                    ${this.calculateTotalCost()}
                                </Typography.Title>
                            </Col>
                        </Row>
                        <Divider />
                        <Row gutter={[16, 16]}>
                            <Col>
                                <Checkbox onChange={(e) => this.setState({agreeTerms: e.target.checked})}>
                                    I hereby acknowledge that I have read, understand and agree Priority Prospect OÜ's <a href='https://priorityprospect.com/legal/done-for-you-pbn-terms-of-service/' target='_blank' rel='noopener noreferrer'><b>"Done-for-you PBN" service's terms of service</b></a> and <a href='https://priorityprospect.com/legal/privacy-policy/' rel="noopener noreferrer" target='_blank'><b>privacy policy</b></a>.
                                </Checkbox>
                            </Col>
                        </Row>
                        <br />
                        <Row gutter={[16, 16]}>
                            <Col>
                                <Button loading={this.state.loading} disabled={!this.state.agreeTerms || this.state.loading}
                                        onClick={() => this.createOrder()} type='primary'>Create Order</Button>
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col xs={24} md={12}>
                    <Card title='Features' size='small' >
                        <List>
                            <List.Item><CheckSquareOutlined /> 15 articles (10000 - 15000 words total; article length 750-1000 words)</List.Item>
                            <List.Item><CheckSquareOutlined /> Custom logo</List.Item>
                            <List.Item><CheckSquareOutlined /> Default pages (privacy, contact, about, HTML sitemap)</List.Item>
                            <List.Item><CheckSquareOutlined /> Dedicated IP address for 12 months</List.Item>
                            <List.Item><CheckSquareOutlined /> Web hosting for 12 months</List.Item>
                            <List.Item><CheckSquareOutlined /> Hand-picked royalty-free images</List.Item>
                            <List.Item><CheckSquareOutlined /> Website optimization (closed comments, caching, sitemaps, and more)</List.Item>
                            <List.Item><CheckSquareOutlined /> All niches accepted</List.Item>
                            <List.Item><CloseSquareOutlined /> Domain not included; white glove domain service available</List.Item>
                        </List>
                    </Card>
                    <br />
                    <Card title='White glove domain service' size='small'>
                        <p>As part of this service, our customers gain exclusive access to a curated selection of premium domains through our partnership with <a href='https://odys.global/?utm_campaign=done-for-you-pbn&utm_source=priorityprospect.com' target='_blank' rel='noopener noreferrer'>Odys Global</a>. Domains are carefully selected to align with your budget, niche, and overall strategy.</p>
                        <p>An experienced Odys Global account manager will be assigned to assist you throughout the domain selection process, ensuring you receive personalized recommendations from their extensive premium inventory.</p>
                        <p>Please note:</p>
                        <ul>
                            <li>There is no obligation to purchase any domain.</li>
                            <li>A minimum order of 10 websites is required to access this service.</li>
                        </ul>
                        <p>This offering ensures a highly tailored and efficient experience, helping you acquire domains that enhance the value and effectiveness of your private blog network.</p>
                    </Card>
                </Col>
            </Row>
        );
    }
}

const mapStateToProps = state => ({
    user: state.auth.user
});

export default connect(mapStateToProps, { updatePage, createWebsiteSetupOrder })(DoneForYouPBN);